import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import {
  useSendExperimentsToDataDog,
  useSendNativeDeviceTypeToDD
} from '../common';

const useSetDataDogContext = () => {
  const isReturningUser = useGetIsReturnUser();
  useSendExperimentsToDataDog();
  useSendNativeDeviceTypeToDD();

  useEffect(() => {
    datadogRum.setGlobalContextProperty('isReturningUser', isReturningUser);
  }, [isReturningUser]);
};

export default useSetDataDogContext;
